import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchRentalDashboard,
  fetchAdminRentalDashboard,
} from '../../Redux/Actions/actions';
import RentalDashboard from '../../Components/RentalDashboard/RentalDashboard';
import style from './RentalManagement.module.css';

const RentalManagement = () => {
  const dispatch = useDispatch();
  const {
    rentalDashboard,
    adminRentalDashboard,
    rentalsLoading,
    adminRentalsLoading,
    rentalsError,
    adminRentalsError,
  } = useSelector((state) => state);

  useEffect(() => {
    dispatch(fetchRentalDashboard());
    dispatch(fetchAdminRentalDashboard());
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch(fetchRentalDashboard());
    dispatch(fetchAdminRentalDashboard());
  };

  const isLoading =
    (rentalsLoading || adminRentalsLoading) &&
    !rentalDashboard &&
    !adminRentalDashboard;

  if (isLoading) {
    return (
      <div className={style.container}>
        <div className={style.loading}>Cargando dashboard de alquileres...</div>
      </div>
    );
  }

  const combinedError = rentalsError && adminRentalsError ? rentalsError : null;
  if (combinedError) {
    return (
      <div className={style.container}>
        <div className={style.error}>
          Error al cargar el dashboard: {combinedError}
        </div>
      </div>
    );
  }

  return (
    <div className={style.container}>
      <h1 className={style.title}>Gestión de Alquileres</h1>

      <RentalDashboard
        data={rentalDashboard}
        adminData={adminRentalDashboard}
        onRefresh={handleRefresh}
      />
    </div>
  );
};

export default RentalManagement;